export const ROUTES = {
  home: '/',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  adminLogin: '/admin/login',

  dashboard: '/dashboard',
  dashboardAirtime: '/dashboard/airtime',
  dashboardData: '/dashboard/data',
  dashboardElectricity: '/dashboard/bills/electricity',
  dashboardCableTv: '/dashboard/bills/cable-tv',
  dashboardExams: '/dashboard/bills/exams',
  dashboardServices: '/dashboard/services',
  dashboardVerifyNin: '/dashboard/verify/nin',
  dashboardVerifyNinSlip: '/dashboard/verify/nin/:slipType',
  dashboardVerifyBvn: '/dashboard/verify/bvn',
  dashboardTransactions: '/dashboard/transactions',
  dashboardProfile: '/dashboard/profile',
  dashboardSecurity: '/dashboard/security',
  dashboardContactSupport: '/dashboard/contact-support',
  dashboardMore: '/dashboard/more',

  adminRoot: '/admin',
  adminProfile: '/admin/profile',
  adminUsers: '/admin/users',
  adminUserDetail: '/admin/users/:id',
  adminTransactions: '/admin/transactions',
  adminTransactionDetail: '/admin/transactions/:id',
  adminSettings: '/admin/settings',
  adminVirtualAccounts: '/admin/virtual-accounts',
  adminAirtimePricing: '/admin/pricing/airtime',
  adminDataPlans: '/admin/data/plans',
  adminBillPricing: '/admin/bills/pricing',
  adminVerificationPricing: '/admin/verification/pricing',
} as const;

export const PUBLIC_ANCHORS = {
  home: '#home',
  services: '#services',
  about: '#about',
  contact: '#contact',
} as const;
